import '../scss/app.scss'

class App {
    constructor() {
        this.bindNavSearch()
        this.bindNavFilter()
    }

    bindNavSearch() {
        const openBtn = document.querySelector('[data-nav-search-open]')
        const overlay = document.querySelector('[data-nav-search-overlay]')
        const closeBtn = document.querySelector('[data-nav-search-close]')
        if (!openBtn || !overlay) return

        openBtn.addEventListener('click', () => {
            overlay.classList.add('is-open')
            overlay.setAttribute('aria-hidden', 'false')
            document.body.style.overflow = 'hidden'
            const input = overlay.querySelector('#nav-search-input')
            if (input) setTimeout(() => input.focus(), 100)
        })

        const close = () => {
            overlay.classList.remove('is-open')
            overlay.setAttribute('aria-hidden', 'true')
            document.body.style.overflow = ''
        }

        closeBtn?.addEventListener('click', close)
        overlay.addEventListener('click', (e) => { if (e.target === overlay) close() })
        document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && overlay.classList.contains('is-open')) close() })
    }

    bindNavFilter() {
        const openBtn = document.querySelector('[data-nav-filter-open]')
        const overlay = document.querySelector('[data-nav-filter-overlay]')
        const closeBtn = document.querySelector('[data-nav-filter-close]')
        const resetBtn = document.querySelector('[data-nav-filter-reset]')
        if (!openBtn || !overlay) return

        openBtn.addEventListener('click', () => {
            overlay.classList.add('is-open')
            overlay.setAttribute('aria-hidden', 'false')
            document.body.style.overflow = 'hidden'
        })

        const close = () => {
            overlay.classList.remove('is-open')
            overlay.setAttribute('aria-hidden', 'true')
            document.body.style.overflow = ''
        }

        closeBtn?.addEventListener('click', close)
        overlay.addEventListener('click', (e) => { if (e.target === overlay) close() })
        document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && overlay.classList.contains('is-open')) close() })

        resetBtn?.addEventListener('click', () => {
            const url = resetBtn.getAttribute('data-nav-filter-reset-url')
            if (url) {
                window.location.href = url
            } else {
                overlay.querySelectorAll('.nav-filter-screen__checkbox').forEach(cb => { cb.checked = false })
            }
        })
    }
}

new App()